import { IDashPerformance } from '@nkr/models/index';
import { Table } from 'react-bootstrap';

interface IProps {
    data: IDashPerformance,
    formattedStartDate: string,
    formattedEndDate: string,
}

const Performance = (props: IProps) => {
    let { data: performance, formattedStartDate, formattedEndDate } = props;

    return (
        <Table bordered striped>
            <thead>
                <tr >
                    <th colSpan={3} style={{ background: '#337ab7', color: 'white' }}><span style={{ float: 'left' }}>Performance </span> <span style={{ float: 'right' }}>({formattedStartDate} - {formattedEndDate})</span></th>
                </tr>
                <tr>
                    <th style={{ backgroundColor: '#f0f0f0' }}>Status</th>
                    <th style={{ textAlign: 'center', backgroundColor: '#f0f0f0' }}>Avg. Wait (current)</th>
                    <th style={{ textAlign: 'center', backgroundColor: '#f0f0f0' }}>Avg. Wait (historical)</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Record Disposition:</td>
                    <td style={{ textAlign: 'center' }}>{performance.currentAvgWaitDisposition ? performance.currentAvgWaitDisposition : '--'}</td>
                    <td style={{ textAlign: 'center' }}>{performance.avgWaitDisposition ? performance.avgWaitDisposition : '--'}</td>
                </tr>
                <tr>
                    <td>EMR Registration:</td>
                    <td style={{ textAlign: 'center' }}>{performance.currentAvgWaitEmrRegistration ? performance.currentAvgWaitEmrRegistration : '--'} </td>
                    <td style={{ textAlign: 'center' }}>{performance.avgWaitEmrRegistration ? performance.avgWaitEmrRegistration : '--'} </td>
                </tr>
                <tr>
                    <td>Donor Completes History:</td>
                    <td style={{ textAlign: 'center' }}>{performance.currentAvgWaitFinishHistory ? performance.currentAvgWaitFinishHistory : '--'} </td>
                    <td style={{ textAlign: 'center' }}>{performance.avgWaitFinishHistory ? performance.avgWaitFinishHistory : '--'}</td>
                </tr>
                <tr>
                    <td>Mark Completed:</td>
                    <td style={{ textAlign: 'center' }}>{performance.currentAvgWaitCompleted ? performance.currentAvgWaitCompleted : '--'}</td>
                    <td style={{ textAlign: 'center' }}>{performance.avgWaitCompleted ? performance.avgWaitCompleted : '--'}</td>
                </tr>
            </tbody>
        </Table>
    );
}

export default Performance;